<!--
  @Author: DKing
  @Desc: 主页
  @Date: 2019-07-12 17:38:31
-->
<template>
  <div class="nav-page-main">
    <!--导航头-->
    <div class="nav-header">
      <!--横向导航-->
      <div class="nav-col nav-col-position">
        <span class="nav-login-account" v-cloak>{{
          userMessage.companyName
        }}</span>
        <!-- 退出入口 -->
        <el-select
          v-model="configChoose"
          width="50px"
          placeholder="请选择"
          value="请选择"
          @change="chooseConfig"
          class="choose-config"
        >
          <el-option :label="'修改密码'" :value="'change'"></el-option>
          <el-option :label="'切换账号'" :value="'selectAcc'"></el-option>
          <el-option :label="'退出'" :value="'quit'"></el-option>
        </el-select>
      </div>

      <!--面包屑导航-->
      <!-- activeNavFlag 首页不加载面包屑导航 -->
      <div class="nav-crumbs" v-if="activeNavFlag">
        <span class="title" v-cloak>{{ $route.meta.title }}</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item
            v-for="item in $route.meta.breadcrumb"
            :key="item.id"
          >
            <router-link
              class="father-page"
              v-show="item.path !== ''"
              :to="{ path: item.path }"
              v-cloak
              >{{ item.name }}
            </router-link>
            <span class="father-page" v-show="item.path === ''" v-cloak>{{
              item.name
            }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item class="current-page" v-cloak>{{
            $route.meta.title
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!--侧导航-->
    <div class="slide-nav">
      <!--左侧logo-->
      <div class="nav-logo">
        <div class="logoImg">
          <img class="logo" :src="resOemInfo.webNavigationLogo" />
        </div>
      </div>
      <!--左侧菜单组件-->
      <el-menu
        :default-active="activeNavIndex"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        background-color="#051A33"
        text-color="#fff"
        active-text-color="#fff"
      >
        <!--遍历菜单变量，生成一级菜单，根据children的length判断是生成直接菜单还是含有子集菜单-->
        <span v-for="level1 of menuList" :key="level1.index">
          <!--如果length>0 证明有子集，生成含有子集的菜单-->
          <el-submenu
            :index="String(level1.index)"
            v-show="level1.children.length > 0"
          >
            <!--菜单信息-->
            <template slot="title">
              <img class="menu-icon" :src="level1.icon" alt />
              <span v-cloak>{{ level1.name }}</span>
            </template>
            <!--遍历菜单，生成二级菜单，根据children的length判断是生成直接菜单还是含有子集菜单-->
            <span v-for="level2 of level1.children" :key="String(level2.index)">
              <!--如果length>0 证明有子集，生成含有子集的菜单-->
              <el-submenu
                :index="String(level2.index)"
                v-show="level2.children.length > 0"
              >
                <template slot="title" v-cloak>{{ level2.name }}</template>
                <el-menu-item
                  v-for="level3 of level2.children"
                  :index="String(level3.index)"
                  :key="String(level3.index)"
                  background-color="#020D1A"
                  @click="jumpRouter(level3.path)"
                  v-cloak
                  >{{ level3.name }}</el-menu-item
                >
              </el-submenu>
              <!--如果length < 1 证明没有子集，生成直接菜单-->
              <el-menu-item
                :index="String(level2.index)"
                v-show="level2.children.length < 1"
                @click="jumpRouter(level2.path)"
                v-cloak
                >{{ level2.name }}</el-menu-item
              >
            </span>
          </el-submenu>
          <!--如果length < 1 证明没有子集，生成直接菜单-->
          <el-menu-item
            v-show="level1.children.length < 1"
            :index="String(level1.index)"
            @click="jumpRouter(level1.path)"
          >
            <img class="menu-icon" :src="level1.icon" alt />
            <span slot="title" v-cloak>{{ level1.name }}</span>
          </el-menu-item>
        </span>
      </el-menu>
    </div>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form
        :model="paramChangePwd"
        :rules="rules"
        :label-width="forms.labelMiddleWidth"
        ref="rules"
      >
        <el-form-item label="用户名：">
          <span v-cloak>{{ this.userMessage.userName }}</span>
        </el-form-item>
        <el-form-item label="旧密码：" prop="oldPwd">
          <el-input
            v-model="paramChangePwd.oldPwd"
            placeholder="请输入"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPwd">
          <el-input
            v-model="paramChangePwd.newPwd"
            placeholder="请输入"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPwd">
          <el-input
            v-model="paramChangePwd.confirmPwd"
            placeholder="请输入"
            type="password"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('rules')">取 消</el-button>
        <el-button type="primary" @click="xhrChangePwd('rules')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <div id="pageRouter">
      <router-view />
    </div>
  </div>
</template>
<script>
import {
  checkNull,
  getLocal,
  setLocal,
  priceToThousands,
  fenToYuan,
  fenToYuanToDecimal4,
  clearLocal,
  delLocal,
  clearSession
} from "../../filters/filters";
import { DIALOG_CONST, FORMS } from "../../service/businessConsts";
import { HTTP_CODE } from "../../service/axios_constants";
import RULES from "../../FormVerification/index"; //表单校验
import "video.js/dist/video-js.css";

export default {
  name: "home-page",
  inject: ["reload"],
  components: {},
  computed: {},
  data() {
    return {
      userMessage: {}, //登陆用户信息
      formLabelWidth: DIALOG_CONST.labelWidth,
      forms: FORMS,
      rules: RULES, //表单校验
      paramChangePwd: {
        //修改密码参数
        oldPwd: "", //旧密码
        newPwd: "", //新密码
        confirmPwd: "", //确认新密码
        userId: "" //用户id
      },
      dialogFormVisible: false,
      configChoose: "个人中心",
      menuList: [], //菜单list
      activeNavIndex: "", // 当前导航页面
      activeNavFlag: true,
      resOemInfo: {
        customerPhone: "",
        webNavigationLogo: ""
      },
      accountBalance: {},
      sysType: "",
      companyType: "",
      pollingInterval: null // 轮询
    };
  },
  created() {
    if (!checkNull(getLocal("userMessage"))) {
      this.userMessage = JSON.parse(getLocal("userMessage"));
    }

    // nav-crumbs是否展示
    if (
      this.$route.path === "/home/" ||
      this.$route.path === "/indexAg" ||
      this.$route.path === "/indexMer"
    ) {
      this.$data.activeNavFlag = false;
    }
    this.telFunction();
  },

  beforeMount() {
    // this.startPolling();
  },

  watch: {
    $route(to, from) {
      // TODO: nav-crumbs是否展示
      if (
        to.path === "/home/" ||
        this.$route.path === "/indexAg" ||
        this.$route.path === "/indexMer"
      ) {
        this.$data.activeNavFlag = false;
      } else {
        this.$data.activeNavFlag = true;
      }
    }
  },
  mounted() {
    this.showJurisdiction();
  },

  beforeDestroy() {
    this.stopPolling();
  },

  methods: {
    // 开始轮询
    startPolling() {
      this.pollingInterval = setInterval(() => {
        if (getLocal("userMessage")) {
          const newData = JSON.parse(getLocal("userMessage")).userId;
          if (newData !== this.userMessage.userId) {
            window.location.reload();
          }
        }
      }, 500);
    },

    // 结束轮询
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },

    //判断是否有客服电话
    telFunction() {
      if (!checkNull(localStorage.getItem("resOemInfo"))) {
        let resOemInfo = getLocal("resOemInfo");
        if (!checkNull(resOemInfo)) {
          this.resOemInfo = resOemInfo;
        }
      }
    },

    showJurisdiction() {
      if ("userId" in this.userMessage) {
        //子账号登录
        //查询子账号菜单权限
        this.$http.postselChildAccountCooperatorMenus().then(res => {
          if (!checkNull(res.data)) {
            this.menuList = JSON.parse(res.data);
          }

          // 先判断本地是否存在 后判断是否有权限没有则跳到首页 / 本地不存在也跳首页 ljl 扬小雨提bug
          // if (!checkNull(getLocal("activeNavIndex"))) {
          //   // 递归
          //   let index = getLocal("activeNavIndex");
          //   let arr = this.findIndex(index, this.menuList);
          //   if (!!arr && arr.length > 0) {
          //     this.activeNavIndex = JSON.stringify(arr[0].index);
          //     this.$router.push({ name: arr[0].path });
          //   } else {
          //     this.activeNavIndex = JSON.stringify(this.menuList[0].index);
          //     this.$router.push({ name: this.menuList[0].path });
          //   }
          // } else {
          //   this.activeNavIndex = JSON.stringify(this.menuList[0].index);
          //   this.$router.push({ name: this.menuList[0].path });
          // }

          // 判断local是否已经存在路径的index，为空则默认跳到首页
          if (checkNull(getLocal("activeNavIndex"))) {
            this.activeNavIndex = this.menuList[0].id;
            this.$router.push({ name: this.menuList[0].path });
          } else {
            this.activeNavIndex = getLocal("activeNavIndex");
          }
        });
      }
    },

    // xhr -- 获取可用余额接口
    xhrGetAccountBalance() {
      this.$http.getCurrentAccountBalance().then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (res.data.creditAmount > 0) {
            this.accountBalance.showText = true;
          }
          // balance保留四位小数
          this.accountBalance.balance = priceToThousands(
            fenToYuanToDecimal4(res.data.balance)
          );
          this.accountBalance.creditAmount = priceToThousands(
            fenToYuan(res.data.creditAmount)
          );
        }
      });
    },

    //修改密码
    xhrChangePwd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var prams = {
            ...this.paramChangePwd
          };
          prams.oldPwd = prams.oldPwd;
          if (prams.newPwd && prams.confirmPwd) {
            prams.newPwd = prams.newPwd;
            prams.confirmPwd = prams.confirmPwd;
          }
          this.$http.postUpdatePasswd(prams).then(res => {
            if (res.statusCode === HTTP_CODE.suc) {
              this.pathLogin();
              this.$message({
                type: "success",
                message: "修改密码成功"
              });
              //修改密码后更新本地存储密码
              if (!checkNull(getLocal("checked"))) {
                if (!checkNull(getLocal("password"))) {
                  setLocal("password", this.paramChangePwd.newPwd);
                }
              }
            } else if (res.statusCode === HTTP_CODE.warn) {
              this.$message({
                type: "warning",
                message: res.statusText
              });
            }
          });
        }
      });
    },

    resetForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },

    jumpRouter(path) {
      this.$router.push({ name: path });
    },

    chooseConfig() {
      if (this.configChoose === "change") {
        this.dialogFormVisible = true;
      } else if (this.configChoose === "quit") {
        this.pathLogin();
      } else if (this.configChoose === "selectAcc") {
        this.$router.push({
          path: "/selectAcc"
        });
      }
      this.configChoose = "个人中心";
    },

    /**
     *@desc  退出登陆
     */
    pathLogin() {
      let param = {
        phoneNo: this.userMessage.phoneNo
      };
      this.$http.postBowOut(param).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          this.userMessage = {};
          this.$router.push({
            path: "/"
          });
          clearLocal();
          clearSession();
        }
      });
    },

    handleSelect(key, keyPath) {
      setLocal("activeNavIndex", key);
    },

    // 递归查询
    findIndex(v, list) {
      let data;
      (list || []).map(i => {
        if (i.index == v) {
          data = [i];
        } else {
          const child = this.findIndex(v, i.children);
          if (child) {
            data = child;
          }
        }
      });
      return data;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/variable";
.wechat-enter {
  position: relative;
  margin-left: 29px;

  .wechat-enter-img {
    width: 32px;
    height: 32px;
  }
}

.el-select .el-input--suffix {
  width: 70px;
}

.el-submenu__title {
  background-color: #fff !important;
}

.nav-page-main {
  height: 100%;
  .nav-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    z-index: 1;
    .nav-col {
      width: calc(100% - 256px);
      width: 100%;
      height: 64px;
      background: #ffffff;
      box-shadow: 0 1px 4px 0 rgba(5, 26, 51, 0.08);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 24px;
    }

    .nav-crumbs {
      width: calc(100% - 256px);
      margin-left: 256px;
      padding-left: 32px;
      position: relative;
      top: 1px;
      display: flex;
      align-items: center;
      background-color: #fff;
      height: 80px;
      .father-page {
        font-size: 12px;
        color: $fontColorIgnore;
      }
      .title {
        color: #272727;
        font-size: 24px;
        font-weight: 500;
        margin-right: 24px;
      }
    }
  }
  .slide-nav {
    width: 256px;
    height: 100%;
    background: #051a33;
    position: absolute;
    top: 0px;
    z-index: 1000;
    overflow-y: auto;
    .nav-logo {
      z-index: 999;
      background-color: #08284d;
      padding: 12px 28px;
      height: 64px;
      // width: 256px;
      .logoImg {
        width: 100%;
        height: 40px;
        .logo {
          width: 100%;
          height: 100%;
        }
      }
    }
    .menu-icon {
      width: 16px;
      height: 16px;
      margin-right: 12px;
      margin-top: -2px;
    }
  }
  .el-menu.el-menu--inline {
    background-color: #020d1a;
  }
  #pageRouter {
    height: calc(100% - 200px);
    width: calc(100% - 304px);
    position: relative;
    top: 24px;
    left: 280px;
    text-align: left;
  }

  /*视频播放*/
  .video-modal {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    top: 0;
    min-height: 500px;
    text-align: center;
    z-index: 990;
  }
  .video-part {
    z-index: 9999;
    position: absolute;
    top: 96px;
    left: 288px;
    width: 70%;
    /*width: 800px;*/
    /*height: 500px;*/
  }
}

.serviceTelephone {
  font-size: 14px;
  font-weight: normal;
  margin-right: 24px;

  i {
    font-style: normal;
  }
}

.num-right {
  position: absolute;
  left: 280px;
  img {
    float: left;
    margin-right: 8px;
  }
  span {
    margin-left: 8px;
    color: #595959;
    float: left;
    font-size: 14px;
  }
  a {
    color: #1a85ff;
    font-size: 14px;
    float: left;
  }
}
.recharge-btn {
  color: #1985ff;
  margin: 0 24px 0 8px;
  cursor: pointer;
}
.balance-text {
  color: #595959;
}
.balance-num {
  color: $colorPrice;
}

.dianzi-part {
  margin-right: 24px;
}
</style>
<style>
.wechat-posi img {
  width: 144px;
  height: 144px;
  margin: 0 auto;
}

.wechat-posi span {
  margin-top: 3px;
  display: block;
  text-align: center;
}

.choose-config .el-input__suffix-inner {
  top: -2px;
  position: relative;
}
.el-select .el-input__icon {
  height: auto;
}

.el-breadcrumb {
  line-height: 64px;
}

.nav-col .el-input--suffix .el-input__inner {
  border: none;
  width: 121px;
  padding: 0;
  text-align: center;
}

.el-menu-item.is-active {
  background-image: linear-gradient(269deg, #24b5ff 0%, #0f53ff 100%);
  border-radius: 4px;
  width: calc(100% - 16px);
  height: 40px;
  margin: 12px 8px;
  line-height: 40px;
  opacity: 1;
  font-weight: 500;
}

.el-menu-item,
.el-submenu__title {
  height: 64px;
  line-height: 64px;
  text-align: left;
  opacity: 0.6;
}

.el-menu-item-group__title {
  text-align: left;
}

.el-menu {
  border: none;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 800;
  color: #595959;
  font-size: 12px;
}

.el-menu-vertical-demo {
  height: 90%;
}

.el-menu.el-menu--inline {
  background-color: #020d1a !important;
}

.nav-col-position {
  position: relative;
}

/*视频播放按钮样式*/
.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);

  font-size: 3.5em;

  border-radius: 50%;

  height: 1.5em !important;

  line-height: 2em !important;

  margin-top: -1em !important;

  width: 1.5em !important;
  /*left: 380px;*/
  /*top: 230px;*/
  left: 50%;
  top: 50%;
}

.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  position: absolute;

  top: -9px !important;

  left: 0;

  width: 100%;

  height: 100%;
}

.video-part button {
  outline-style: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue